import { render, staticRenderFns } from "./AppEmpty.vue?vue&type=template&id=3465af22&scoped=true&"
import script from "./AppEmpty.vue?vue&type=script&lang=ts&"
export * from "./AppEmpty.vue?vue&type=script&lang=ts&"
import style0 from "./AppEmpty.vue?vue&type=style&index=0&id=3465af22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3465af22",
  null
  
)

export default component.exports